// Landuse layer field names
export const LANDUSE_CONTEXT = 'Context2'
export const ST_NAME = 'FENAME'
export const ST_TYPE = 'FETYPE'
export const PED_TIER = 'Ped_Tier'
export const BIKE_TIER = 'Bike_Tier'
export const TRANSIT_TIER = 'Transit_Tier'
export const AUTO_TIER = 'Auto_Tier'
export const FREIGHT_TIER = 'Freight_Tier'

// Webmap Layer Names
export const LANDUSE_LAYER = 'Land Use Context'
export const COUNTY_BOUNDARIES_LAYER = 'County Boundaries'
export const PEDESTRIAN_LAYER = 'Pedestrian'
export const BIKE_LAYER = 'Bike'
export const TRANSIT_LAYER = 'Transit'
export const AUTO_LAYER = 'Auto'
export const FREIGHT_LAYER = 'Freight'
export const PED_LANDUSECONTEXT = 'Land Use Context'
export const PED_TRANSIT_TIER = 'Transit Tier 1'
export const PED_DEMAND_AREA = ' Bike & Pedestrian Demand Area'

export const BIKE_STRAVA = 'Strava Bike Activity'
export const BIKE_DEMAND_AREA = ' Bike & Pedestrian Demand Area'
export const BIKE_PL_ON_ROAD = 'Planned, On Road'
export const BIKE_EX_ON_ROAD = 'Existing, On Road'
export const BIKE_PL_PATH = 'Planned, Path'
export const BIKE_EX_PATH = 'Existing, Path'

export const FREIGHT_FAF4 = 'FAF4'
export const FREIGHT_TRUCK_RT = 'SEMCOG Truck Route'
export const FREIGHT_ACT_CENTER = 'Freight Activity Centers'

export const AUTO_MDOT_TRUNKLINES = 'MDOT Trunklines'
export const AUTO_MDOT_ROUTE = 'MDOT Route'
export const AUTO_TIER1 = 'Tier 1 - National Functional Classification'
export const AUTO_TIER2 = 'Tier 2 - National Functional Classification'

export const TRANSIT_REF_LAYER_1 = 'Detroit People Mover'
export const TRANSIT_REF_LAYER_2 = 'Amtrak Routes'
export const TRANSIT_REF_LAYER_3 = 'SEMCOG Transit Activity Center'
export const TRANSIT_SMART = 'SMART'
export const TRANSIT_DDOT = 'DDOT'
export const TRANSIT_RIDE = 'TheRide'
export const TRANSIT_BWAT = 'BWAT'
export const TRANSIT_PLANNED = 'Planned'
export const TRANSIT_LET = 'LET'
export const TRANSIT_FAST = 'FAST'
export const TRANSIT_QLINE = 'QLine'
export const TRANSIT_UM = 'UM'

// Pedestrian Layer Field Names
export const PED_NETWORK = 'PedNetwork'
